import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectLoggedInUserId } from 'store/user/selectors.js/user.selectors';
import { selectAllowancesCreateParams } from '../selectors/records-base.selectors';
import { selectSelectedRecord } from '../selectors/records.selectors';
import { createAbsenceRecordsByTimeframe } from './createAbsenceRecordsByTimeframe.thunk';

export const distributeAllowanceOperationsByAllowancesCreateParams =
  createAsyncThunk(
    'records/handleClockOutAllowances',
    async (_, { getState, dispatch }) => {
      const clockOutAllowances = selectAllowancesCreateParams(getState());
      const mirrorUser = selectLoggedInUserId(getState());
      const selectedRecord = selectSelectedRecord(getState());

      const absenceRecordAllowancesParams = clockOutAllowances.filter(
        (params) => {
          return params.type.includes('ABSENCE');
        }
      );

      absenceRecordAllowancesParams.forEach((params) => {
        dispatch(
          createAbsenceRecordsByTimeframe({
            type: params.type,
            startDateUtc: params.startDate,
            endDateUtc: params.endDate,
            projectId: selectedRecord.project,
            resourceId: selectedRecord.resource,
            mirrorUser: mirrorUser,
            subType: params.subType,
          })
        );
      });
    }
  );
